import ExternalNetworkService from './ExternalNetworkService';
import ApiService from '@/services/ApiService';

/**
 * OpenNavent/ZonaProp external network service
 */
/* eslint-disable class-methods-use-this */
class OpenNaventService extends ExternalNetworkService {
  constructor() {
    super('opennavent');
  }

  /**
   * Get quick display data for an OpenNavent property
   * @param {string|number} id - Posting hash/identifier
   * @returns {Promise} Property data
   */
  async getQuickData(id) {
    const composedURL = `/portals/opennavent/api3/posting/${id}`;
    return ApiService.get(composedURL, undefined, true);
  }

  /**
   * Get properties by hash list
   * @param {Array<string>} hashes - List of posting hashes
   * @returns {Promise} Properties data
   */
  async getPropertiesByIdentifiers(hashes) {
    const listOfPropertiesHash = Array.isArray(hashes)
      ? hashes.join(',')
      : hashes;
    const composedURL = `/portals/opennavent/api3/posting/properties_card?properties_posting_hash=${listOfPropertiesHash}`;
    return ApiService.get(composedURL);
  }

  /**
   * Get info for contact form
   * @param {string|number} id - Posting hash
   * @returns {Promise} Contact info
   */
  async getInfoForContact(id) {
    const composedURL = `/api3/property/get_info_for_contact?posting_hash=${id}`;
    return ApiService.get(composedURL);
  }

  /**
   * Contact real estate agent
   * @param {Object} data - Contact form data
   * @returns {Promise} Response
   */
  async contactRealState(data) {
    const composedURL = '/api3/property/contact_real_state';
    return ApiService.post(composedURL, data);
  }
}
/* eslint-enable class-methods-use-this */

export default OpenNaventService;
